(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyPaymentLogDialogController', CompanyPaymentLogDialogController);

    CompanyPaymentLogDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CompanyPaymentLog', 'AccountClearingRequest', 'Company'];

    function CompanyPaymentLogDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, CompanyPaymentLog, AccountClearingRequest, Company) {
        var vm = this;

        vm.companyPaymentLog = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.accountclearingrequests = AccountClearingRequest.query();
        vm.companies = Company.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.companyPaymentLog.id !== null) {
                CompanyPaymentLog.update(vm.companyPaymentLog, onSaveSuccess, onSaveError);
            } else {
                CompanyPaymentLog.save(vm.companyPaymentLog, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:companyPaymentLogUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
